/**
 * 
 * Private module handling deserialization of geo internal objects.
 *
 * @module geo/deserializer
 * @preferred
 * @private
 * @internalapi
 * 
 * 
 * @since v 2.0.1
 * 
 * 
 * @external
 */

import {Store} from 'redux';

import {Functionality} from '../functionalities';
import {Analysis2Functionality, AnalysisFunctionality} from '../functionalities/analysis';
import {GeometryModificationFunctionality} from '../functionalities/geometry.modification';
import {InfoSheetFunctionality} from '../functionalities/infosheet';
import {SearchFunctionality} from '../functionalities/search';
import {StatisticFunctionality} from '../functionalities/statistic';
import {GroupMapEntry} from '../map/layer/group.map.entry';
import {MapEntry} from '../map/layer/map.entry';
import {RasterMapEntry} from '../map/layer/raster.map.entry';
import {SpatialDataMapEntry} from '../map/layer/spatial.data.map.entry';
import {VectorLayerMapEntry} from '../map/layer/vector.layer.map.entry';
import {WebServiceMapEntry} from '../map/layer/webService.map.entry';
import {AppStore} from '../store/app';
import {FunctionalityOptions} from '../types/functionality';
import {Entry} from '../types/map/entry';

/**
 * Used in deserialize MapEntry given from the internal Api to a typed MapEntry.
 * See [[GeoMap]] .
 * @since v2.0.1
 * @internalapi
 * @private
 * 
 */
export class MapEntryDeserializer {
  static build(iEntry: Entry, store: Store<AppStore>): MapEntry {
    if (MapEntry.isOfType(iEntry, GroupMapEntry)) {
      return new GroupMapEntry(iEntry, store);
    }
    if (MapEntry.isOfType(iEntry, VectorLayerMapEntry)) {
      return new VectorLayerMapEntry(iEntry, store);
    }
    if (MapEntry.isOfType(iEntry, SpatialDataMapEntry)) {
      return new SpatialDataMapEntry(iEntry, store);
    }
    if (MapEntry.isOfType(iEntry, RasterMapEntry)) {
      return new RasterMapEntry(iEntry, store);
    }
    if (MapEntry.isOfType(iEntry, WebServiceMapEntry)) {
      return new WebServiceMapEntry(iEntry, store);
    }

    throw new Error('unrecognized map entry type');
  }
}

/**
 * Used in deserialize Functionality given from the internal Api to a typed Functionality.
 * See [[Functionality]] .
 * @since v2.0.2
 * @internalapi
 * @private
 * 
 */
export class FunctionalityDeserializer {
  static build(iFunctionality: FunctionalityOptions): Functionality {
    if (Functionality.isOfType(iFunctionality, AnalysisFunctionality)) {
      return new AnalysisFunctionality(iFunctionality);
    }
    if (Functionality.isOfType(iFunctionality, Analysis2Functionality)) {
      return new Analysis2Functionality(iFunctionality);
    }
    if (Functionality.isOfType(iFunctionality, SearchFunctionality)) {
      return new SearchFunctionality(iFunctionality);
    }
    if (Functionality.isOfType(iFunctionality, InfoSheetFunctionality)) {
      return new InfoSheetFunctionality(iFunctionality);
    }
    if (Functionality.isOfType(
            iFunctionality, GeometryModificationFunctionality)) {
      return new GeometryModificationFunctionality(iFunctionality);
    }
    if (Functionality.isOfType(iFunctionality, StatisticFunctionality)) {
      return new StatisticFunctionality(iFunctionality);
    }

    throw new Error('unrecognized functionality type');
  }
}
